function setSharedCallback(callback) {
    // 分享成功之后调用，有可能调用顺序不安全
    var originalShared;
    if (window.thridShareSuccess) {
        originalShared = window.thridShareSuccess;
    }
    if (window.shareActionFinishCall) {
        originalShared = window.shareActionFinishCall;
    }
    function shared(type, status) {
        if (parseInt(status, 10) === 0) {
            status = 'error';
        }
        else {
            status = 'success';
        }
        window.shareActionFinishCall = window.thridShareSuccess = originalShared;
        // window.thridShareSuccess = window.shareActionFinishCall = shared;
        callback(type, status);
    }
    window.thridShareSuccess = window.shareActionFinishCall = shared;
}
export default setSharedCallback;
